<ng-container *ngIf="visible">
  <div class="container-fluid carousel-spacing">
    <osn-shared-carousel-title
      [title]="vm.titleToDisplay"
      [attr.aria-label]="vm.localizedTitles.en"
      [link]="routerLink"
    ></osn-shared-carousel-title>
    <p *ngIf="vm.description">{{ vm.description }}</p>
  </div>
  <osn-shared-carousel
    [vm]="carouselViewModel"
    [carouselTitle]="vm.localizedTitles.en"
    [showSeoTitle]="showSeoTitle"
    (carouselItemSelect)="onCarouselItemSelect($event)"
    (carouselItemImpression)="onCarouselItemImpression($event)"
  ></osn-shared-carousel>
</ng-container>
